// extracted by mini-css-extract-plugin
export var bodyRow = "_gw-d";
export var cardColumns = "_gw-e";
export var ellipsesOverflow = "_gw-2";
export var flatBottomCorners = "_gw-3";
export var flatTopCorners = "_gw-4";
export var headerActionsDropdown = "_gw-f";
export var headerBottomRow = "_gw-c";
export var headerTopRow = "_gw-b";
export var orderDetailsWrapper = "_gw-0";
export var orderInfoContainer = "_gw-1";
export var productDetails = "_gw-9";
export var productImage = "_gw-5";
export var responsiveTable = "_gw-8";
export var shipmentContainer = "_gw-a";
export var tableBottomLeft = "_gw-6";
export var tableBottomRight = "_gw-7";